/* unplugin-vue-components disabled */import { render } from "./UserSex.vue?vue&type=template&id=607646b3&scoped=true"
import script from "./UserSex.vue?vue&type=script&lang=js"
export * from "./UserSex.vue?vue&type=script&lang=js"

import "./UserSex.vue?vue&type=style&index=0&id=607646b3&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607646b3"]])

export default __exports__